import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";

const CustomGridHeaderCell = (props) => {
  let color = props.color != null ? props.color : "white !important";
  return (
    <Box spacing={0.5}>
      {props.item1 !== undefined ? (
        <Typography
          variant="subtitle2"
          sx={{ height: 20, color: props.item1Color != null ? props.item1Color : color }}
        >
          {props.item1}
        </Typography>
      ) : null}

      {props.item2 !== undefined ? (
        <Stack direction="row" alignItems="center" gap={1} display={props.rowsToDisplay == 1 ? "none" : ""}>
          {props.icon}
          <Typography
            variant="subtitle2"
            sx={{ height: 20, color: props.item2Color != null ? props.item2Color : color }}
          >
            {props.item2}
          </Typography>
        </Stack>
      ) :
      null}
      {props.item3 !== undefined ? (
        <Stack direction="row" alignItems="center" gap={1} display={props.rowsToDisplay == 1 || props.rowsToDisplay == 2 ? "none" : ""}>
          {props.icon}
          <Typography
            variant="subtitle2"
            sx={{ height: 20, color: props.item3Color != null ? props.item3Color : color }}
          >
            {props.item3}
          </Typography>
        </Stack>
      ) :
      null}
    </Box>
  );
};

export default CustomGridHeaderCell;
